<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from 'dashboard/components-next/select/Select.vue';
import Input from 'dashboard/components-next/input/Input.vue';

// Motivo de pérdida — compartido por el modal de cierre y la ficha.
// Con lista configurada = select curado (los motivos consistentes son lo que
// vuelve analizable "¿por qué perdemos?"); sin lista = texto libre opcional.
const props = defineProps({
  modelValue: { type: String, default: '' },
  reasons: { type: Array, default: () => [] },
});
const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const value = computed({
  get: () => props.modelValue || '',
  set: v => emit('update:modelValue', v),
});

// Un motivo histórico que ya no está en la lista (renombrado/quitado) se
// agrega como opción marcada — NUNCA se anula solo (el select en blanco
// pisaría el histórico en el próximo guardado).
const options = computed(() => {
  const opts = [
    { value: '', label: t('LEADS.CLOSE.REASON_PLACEHOLDER') },
    ...props.reasons.map(reason => ({ value: reason, label: reason })),
  ];
  if (props.modelValue && !props.reasons.includes(props.modelValue)) {
    opts.push({
      value: props.modelValue,
      label: t('LEADS.CLOSE.REASON_HISTORIC', { reason: props.modelValue }),
    });
  }
  return opts;
});
</script>

<template>
  <Select v-if="reasons.length" v-model="value" :options="options" />
  <Input
    v-else
    v-model="value"
    :placeholder="t('LEADS.CLOSE.REASON_FREE_PLACEHOLDER')"
  />
</template>
